import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import {useHistory} from "react-router-dom";

const isLocal = process.env.NODE_ENV === "development";

export function initSentry() {
  if (isLocal) {
    return
  }
  Sentry.init({
    dsn: "https://9ce16ba4d33640ee9140fe634e5c36c5@o490175.ingest.sentry.io/5553632",
    autoSessionTracking: true,
    integrations: [
      new Integrations.BrowserTracing(),
    ],
  
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

export function reportSentryError(error, errorInfo = null) {
  if (isLocal) {
    return;
  }

  Sentry.withScope((scope) => {
    errorInfo && scope.setExtras(errorInfo);
    Sentry.captureException(error);
  });
}

export function onError(error) {
  // TODO manage 403 errors by redirecting to login
  let errorInfo = {};
  let message = error.toString();

  // Auth errors
  if (!(error instanceof Error) && error.message) {
    errorInfo = error;
    message = error.message;
    error = new Error(message);
    // API errors
  } else if (error.config && error.config.url) {
    errorInfo.url = error.config.url;
  }

  if (message.indexOf('403') !== -1) {
    window.location.href = "/login";
  }

  reportSentryError(error, errorInfo);
  console.error(error);
  // alert(message);
}